import { Reducer } from "redux";

import { ReferralRequestorResponse } from "../models/Api/ReferralRequest";
import { ReferralRequestorDispatchTypes } from "../models/DispatchTypes/ReferralRequest";
import { ReferralRequestorActionDispatchTypes } from "../constants/ReferralRequestor";

const initialState: ReferralRequestorResponse = {
    loading: false,
    response: {
        lastName: "",
        firstName: "",
        emailAddress: "",
        isPrivacyCheck: false
    },
};

const ReferralRequestor: Reducer<ReferralRequestorResponse, ReferralRequestorDispatchTypes> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ReferralRequestorActionDispatchTypes.REFERRAL_REQUESTOR_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case ReferralRequestorActionDispatchTypes.REFERRAL_REQUESTOR_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
    }
    return state;
};

export default ReferralRequestor;